import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center like-and-comments"
}
const _hoisted_2 = { class: "comments border-top pt-3 mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_likes = _resolveComponent("likes")!
  const _component_comments_counter = _resolveComponent("comments-counter")!
  const _component_comments_list = _resolveComponent("comments-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("span", { class: "likes-and-comments-relative" }, [
      _createElementVNode("span", {
        class: "likes-and-comments-anchor",
        id: "likes-and-comments"
      })
    ], -1)),
    (_ctx.renderComponent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_likes, {
            likedContentUuid: _ctx.articleUuid,
            category: "article"
          }, null, 8, ["likedContentUuid"]),
          _createVNode(_component_comments_counter, {
            "article-uuid": _ctx.articleUuid,
            "use-bold-font": "",
            "article-url": _ctx.articleUrl,
            showSmall: false
          }, null, 8, ["article-uuid", "article-url"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_comments_list, {
        threadId: _ctx.articleUuid,
        forceShowDeleteCommentButtons: _ctx.forceShowDeleteCommentButtons,
        onCommentsChanged: _ctx.forceRerender
      }, null, 8, ["threadId", "forceShowDeleteCommentButtons", "onCommentsChanged"])
    ])
  ], 64))
}